/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Drop_HintInputs */

const en_toast_drop_hint = /** @type {(inputs: Toast_Drop_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop files to import`)
};

const de_toast_drop_hint = /** @type {(inputs: Toast_Drop_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateien hier ablegen`)
};

/**
* | output |
* | --- |
* | "Drop files to import" |
*
* @param {Toast_Drop_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_drop_hint = /** @type {((inputs?: Toast_Drop_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Drop_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_drop_hint(inputs)
	return de_toast_drop_hint(inputs)
});